import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { TextField } from '@mui/material';

const CustomFieldIntegerEditor = ({ value, handleCustomFieldValueChange }) => {
  const [touched, setTouched] = useState(false);

  const handlesBlur = () => setTouched(true);

  return (
    <TextField
      variant="outlined"
      value={value}
      error={touched && !value}
      onBlur={handlesBlur}
      onChange={({ target: { value: newValue } }) => handleCustomFieldValueChange(newValue.replace(/[^0-9]/gi, ''))}
    />
  );
};

const { number, func } = PropTypes;

CustomFieldIntegerEditor.propTypes = {
  value: number,
  handleCustomFieldValueChange: func,
};

export default CustomFieldIntegerEditor;
